import { render } from "./ChartsList.vue?vue&type=template&id=3baba0ac&scoped=true"
import script from "./ChartsList.vue?vue&type=script&lang=js"
export * from "./ChartsList.vue?vue&type=script&lang=js"

import "./ChartsList.vue?vue&type=style&index=0&id=3baba0ac&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3baba0ac"]])

export default __exports__